import React, { useEffect, useState } from "react";
import { Card, Spinner, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import FancyPLMatchWiseTableEventPl from "Common/Tables/eventPlTables/PlMatchWiseTable";
import { authServices } from "Utils/auth/services";
import CustomPagination from "Common/customPagination";

interface EventPlPayload {
  sport_id: string;
  from_date: string;
  to_date: string;
  type: number;
  page: number;
  limit: number;
}



const PlMatchWise: React.FC = () => {
  const { sport_id, sport_name, from_date, to_date, type } = useParams<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [casinoBetsData, setCasinoBetsData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [itemsPerPage, setItemsPerPage] = useState<number>(50);
  const [searchTerm, setSearchTerm] = useState<string>("");

  // Function to get Event PL data
  const getEventPlData = async (page: number = 1) => {
    setIsLoading(true);
    try {
      const payload: EventPlPayload = {
        sport_id: sport_id!,
        from_date: from_date!,
        to_date: to_date!,
        type: Number(type),
        page,
        limit: itemsPerPage,
      };

      const { response } = await authServices.getPlMatchWise(payload);
      const metadata = response?.metadata;

      if (response?.data) {
        setCasinoBetsData(response.data);
        setTotalItems(metadata[0]?.total || 0);
      } else {
        setCasinoBetsData([]);
        setTotalItems(0);
      }
    } catch (error) {
      console.error("Error fetching casino bets data:", error);
      setCasinoBetsData([]);
      setTotalItems(0);
    } finally {
      setIsLoading(false);
    }
  };

  // Handle page change
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getEventPlData(page);
  };

  // Handle items per page change
  const handleItemsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newItemsPerPage = Number(event.target.value);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1); // Reset to first page on change
    getEventPlData(1);
  };

  // Handle search term change
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

// Filtered data based on search term
const filteredData = searchTerm
  ? casinoBetsData.filter((item) =>
      item.match_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      sport_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.total?.toString().includes(searchTerm) // Convert total to string for comparison
    )
  : casinoBetsData;


  // Call API on page load
  useEffect(() => {
    getEventPlData(currentPage);
  }, [sport_id, from_date, to_date, type, itemsPerPage]);
  const handleRowClick = (match_id: string, match_name:String) => {
  
  
    const url = `/plMarketwise/${match_id}/${match_name}/${type}/${sport_id}/${from_date}/${to_date}/`;
    // navigate(url);
    window.open(url, "_blank");

    
};
  return (
    <div className="event-pl">
      <Card>
        <Card.Body>
          {/* <h4>PL Match Wise - {sport_name}</h4> */}

          {/* Search and Items Per Page */}
          <div className="d-flex justify-content-between align-items-center mb-2">
           

            {/* Items Per Page Dropdown */}
            <div className="d-flex gap-2 align-items-center ">
Show
            <select
              className="form-select w-auto"
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
            >
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={150}>150</option>
              <option value={200}>200</option>
            </select>

            Entries
            </div>
             {/* Search Bar */}
             <Form.Control
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="w-25"
            />
          </div>

          {isLoading ? (
            <div className="text-center">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <>
              <FancyPLMatchWiseTableEventPl
                fancyPLData={filteredData}
                sport_name={sport_name}
                onClickRow={handleRowClick}
              />
              <CustomPagination
                currentPage={currentPage}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
              />
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default PlMatchWise;
